<template>
  <header
    class="site-header"
    :class="{ 'open' : isOpen }"
  >

    <span
      v-show="isOpen"
      @click="toggleMenu()"
      class="background"
    ></span>

    <div class="top-border">
        <div class="new-call">
          <a :href="data.aus_link_url" class="aus desktop" :class="{current: isAus}" target="_blank">Australia</a>
          <a :href="data.nz_link_url" class="nz desktop" :class="{current: !isAus}" target="_blank">New Zealand</a>
          <!-- <div class="opacity-50 pipe">|</div> -->
          <!-- TODO: Update to use google translate api -->
          <!-- <div class="lang">
            <div id="header_google_translate_element"></div>
            <span class="material-symbols-outlined notranslate">expand_more</span>
          </div> -->
          <!-- <select name="" id="">
            <option value="">English</option>
          </select> -->
          <span class="ph">
            <p class="free-cta">Free Call from anywhere in Australia <a href="tel:1800141822">1800 14 18 22</a></p>
            <span class="desktop">|</span>
            <a v-if="data.phone_url && data.phone" :href="`tel:${data.phone_url}`" class="header-ph" target="_blank"><span class="free">Free Call NZ </span>{{data.phone}}</a>
          </span>
        </div>

    </div>

    <div class="bottom-nav">
      <a
        href="/"
        class="logo"
        @click="$store.commit('setNotice', true)"
      >
        <img fetchpriority="high" src="/images/logo.webp" alt="Website Logo" />
      </a>

      <nav>

        <ul class="parent">
          <li
            v-for="(link, parentIndex) of menu"
            :key="parentIndex"
            :class="{ selected: activeParents.includes(parentIndex) }"
            @mouseenter="toggleDropdownParent(parentIndex)"
            @mouseleave="startCloseTimeout(parentIndex)"
          >
            <span class="parent link-area">
              <a
                :href="link.url"
                :class="{
                  selected: isLinkSelected(link.url),
                  'has-children': link.children && link.children.length > 0,
                }"
                :target="isLinkExternal(link.url) ? '_target': ''"
              >
                {{ link.title }}
              </a>
              <span
                class="text"
                :class="{
                  selected: isLinkSelected(link.url) || activeParents.includes(parentIndex),
                  'has-children': link.children && link.children.length > 0,
                }"
              >
                {{ link.title }}
              </span>

              <span
                v-if="link.children && link.children.length > 0"
                class="icon mobile material-icons"
              >
                {{ activeParents.includes(parentIndex) ? 'expand_less' : 'expand_more' }}
              </span>
            </span>

            <ul
              v-if="link.children && link.children.length > 0"
              class="child"
              :class="{
                open: activeParents.includes(parentIndex),
                active: activeParents.includes(parentIndex)
              }"
            >
              <li v-if="link.children && link.children.length > 0" class="mobile">
                <a :href="link.url">Overview</a>
              </li>

              <li
                v-for="(child, childIndex) of link.children"
                :key="childIndex"
                :class="{
                  third: child.children && child.children.length > 0,
                  active: activeChildren.includes(childIndex)
                }"
                @mouseenter="toggleDropdownChild(childIndex)"
                @mouseleave="startCloseTimeout(childIndex, true)"
              >
                <span class="link-area">
                  <a
                    :href="child.url"
                    :class="{ 'has-children': child.children && child.children.length > 0 }"
                    :target="isLinkExternal(child.url) ? '_target': ''"
                  >
                    {{ child.title }}
                  </a>
                  <span
                    class="text"
                    :class="{ 'has-children': child.children && child.children.length > 0 }"
                  >
                    {{ child.title }}
                  </span>

                  <span
                    v-if="child.children && child.children.length > 0"
                    class="icon mobile material-icons"
                  >
                    {{ activeChildren.includes(childIndex) ? 'expand_less' : 'expand_more' }}
                  </span>
                </span>

                <ul
                  v-if="child.children && child.children.length > 0"
                  class="third-tier"
                  :class="{
                    open: activeChildren.includes(childIndex)
                  }"
                >
                  <!-- <li class="text-white mobile uppsercase" @click="setMobileState(parentIndex)">
                    <span class="text-[#FDDD00] material-icons">chevron_left</span>
                    {{ child.title }}
                  </li> -->
                  <li
                    v-for="(grandChild, grandChildIndex) of child.children"
                    :key="grandChildIndex"
                  >
                    <a
                      :href="grandChild.url"
                      :target="isLinkExternal(grandChild.url) ? '_target': ''"
                    >{{ grandChild.title }}</a>
                  </li>
                </ul>
              </li>
            </ul>

          </li>
        </ul>
      </nav>

      <button class="hamburger mobile" @click="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    menu: Array,
    data: Object
  },

  data: () => ({
    isOpen: false,
    nav: [],
    level1Active: null,
    level2Active: null,
    activeLevels: {},
    activeParents: [],
    activeChildren: [],
    isAus: false,
    googleTranslateTrackChange: null,
    closeTimeout: null,
  }),

  computed: {
    mobileActiveLevel () {
      if (this.level2Active !== null) {
        return 2
      }

      if (this.level1Active !== null) {
        return 1
      }

      return 0
    },
  },

  async mounted () {
    this.nav = this.menu

    if (this.data?.aus_link_url === window.location.origin) {
      this.isAus = true;
    }

    // this.initGoogleTranslate()
    this.$emit('header-loaded')
  },

  methods: {
    // initGoogleTranslate () {
    //   window.google.translate.TranslateElement(
    //     {
    //       pageLanguage: 'en',
    //       includedLanguages: 'en, de,fr,ja,zh-CN,zh-TW',
    //       gaTrack: true,
    //       gaId: "UA-1969343-15",
    //       autoDisplay: false
    //     }, 'header_google_translate_element')
    // },

    toggleMenu () {
      this.isOpen = !this.isOpen
      this.$parent.navToggle(this.isOpen)

      // reset mobile state if mobile menu is dismissed
      if (!this.isOpen) {
        this.setMobileState()
      }
    },

    toggleDropdownParent(index) {
      // Clear any existing timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout)
        this.closeTimeout = null
      }

      if (!this.activeParents.includes(index)) {
        this.activeParents = [index] // Only keep the current parent active
      }
    },

    toggleDropdownChild(childIndex) {
      // Clear any existing timeout
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout)
        this.closeTimeout = null
      }

      if (!this.activeChildren.includes(childIndex)) {
        this.activeChildren = [childIndex] // Only keep the current child active
      }
    },

    startCloseTimeout(index, isChild = false) {
      this.closeTimeout = setTimeout(() => {
        if (isChild) {
          const childIdx = this.activeChildren.indexOf(index)
          if (childIdx > -1) {
            this.activeChildren.splice(childIdx, 1)
          }
        } else {
          const parentIdx = this.activeParents.indexOf(index)
          if (parentIdx > -1) {
            this.activeParents.splice(parentIdx, 1)
          }
        }
      }, 600)
    },

    setMobileState (level1Active = null, level2Active = null) {
      if (level1Active === this.level1Active) {
        this.level1Active = null
        this.level2Active = null
      } else if (level2Active === this.level2Active) {
        this.level2Active = level2Active
      } else {
        this.level1Active = level1Active
        this.level2Active = level2Active
      }
    },

    isLinkSelected (link) {
      const currentPath = window.location.pathname
      const currentPaths = currentPath.split('/').map((path) => {
        if (path === '' || path.length === 0) return
        if (path.startsWith('http')) return

        return '/' + path
      })
      const linkPaths = link.split('/').map((path) => {
        if (path === '' || path.length === 0) return
        if (path.startsWith('http')) return

        return '/' + path
      })

      if (currentPath === '/') {
        return false
      } else if (link === '/' && currentPath === '/') {
        return true
      } else if (link === currentPath) {
        return true
      } else if (link.includes('/contact') && currentPath.includes('/contact')) {
        return true
      } else if (link !== '/') {
        return currentPath.includes(link)
          || linkPaths.includes(currentPath)
          || linkPaths.some((path) => path !== undefined && currentPaths.includes(path))
      }

      return false
    },

    isLinkExternal (link) {
      const hostname = window.location.hostname
      if (link.startsWith('/') || link === '#') return false

      return !link.includes(hostname) || link.includes('.au')
    }
  }
};
</script>
